import { sendGet } from "./axios";

export const getAreaSummary = () => sendGet("/dm/area/summary");
export const getAreaProvinces = () => sendGet("/dm/area/provinces");
export const getAreaHospitals = (provinceCode) =>
  sendGet(
    `/dm/area/hospitals${provinceCode ? `?province_code=${provinceCode}` : ""}`
  );
